<template>
	<div class="input-container">
		<label >{{label}}</label>
		<textarea @keyup="change" class="textbox"  :placeholder="placeholder" :value="value" :rows="rows"></textarea>
	</div>
</template>
<script>
	export default {
		name:"textbox",
		props:["placeholder","model", "value","label", "rows"],
		methods:{
			change(e){
				this.$emit('input', e.target.value);
			}
		}
	}
</script>
<style scoped>
	.input-container{
	}
	.textbox{
		font-size:14px;
		padding:6px 10px;
		display: block;
		border:1px solid lightgrey;
		border-radius: 4px;
		background: white;
		width: 100%;
		box-sizing: border-box;
		outline:none;
		margin-top:4px;
		margin-bottom:8px;
	}
	.textbox:focus{
		border-color: #27b9ec;
	}
	label{
		font-size:14px;
		font-weight: bold;
	}
</style>